import ImageItemAssetService from 'services/store/itemAsset/subServices/ImageItemAssetService';

export default {
	'services.imageItemAssetService': {
		class: ImageItemAssetService,
	},
};
